<template>
  <ResponseContainer :loading="!group">
    <h2>Edit your RSVP?</h2>
    <p><span class="font-bold">{{ group.name }}</span>, you have already submitted an RSVP.</p>
    <p>Would you like to view or edit?</p>
    <button @click="goToNext()" class="mt-8">Yes, please →</button>
  </ResponseContainer>
</template>

<script>
import ResponseContainer from '@/pages/ResponseContainer'
import Group from '@/models/group'

export default {
  name: 'ResponseRespondedPage',
  components: {
    ResponseContainer,
  },
  data() {
    return {
      group: undefined,
    }
  },
  beforeMount() {
    this.loadParty()
  },
  methods: {
    async loadParty() {
      this.group = await Group.current()
      if (!this.group.rsvped) {
        this.$router.push('/rsvp/name')
      }
    },
    goToNext() {
      this.$router.push('/rsvp/events')
    },   
  },
}
</script>